module.exports = __webpack_public_path__ + "static/media/ivn_onePercentAcademy.5a9ba667.svg";